import { useEffect } from "react";

export default function useSEO({ title, description, canonical, schema }) {
    useEffect(() => {
        // Update Title
        if (title) {
            document.title = `${title} | LÜVYN`;
        }

        // Update Description
        if (description) {
            let metaDescription = document.querySelector('meta[name="description"]');
            if (metaDescription) {
                metaDescription.setAttribute("content", description);
            } else {
                metaDescription = document.createElement("meta");
                metaDescription.name = "description";
                metaDescription.content = description;
                document.head.appendChild(metaDescription);
            }

            // Update OG/Twitter Description
            const ogDesc = document.querySelector('meta[property="og:description"]');
            if (ogDesc) ogDesc.setAttribute("content", description);
            const twDesc = document.querySelector('meta[property="twitter:description"]');
            if (twDesc) twDesc.setAttribute("content", description);
        }

        // Update OG Title
        if (title) {
            const ogTitle = document.querySelector('meta[property="og:title"]');
            if (ogTitle) ogTitle.setAttribute("content", title);
            const twTitle = document.querySelector('meta[property="twitter:title"]');
            if (twTitle) twTitle.setAttribute("content", title);
        }

        // Update Canonical
        if (canonical) {
            let linkCanonical = document.querySelector('link[rel="canonical"]');
            const href = `https://luvyn.com${canonical}`;
            if (linkCanonical) {
                linkCanonical.setAttribute("href", href);
            } else {
                linkCanonical = document.createElement("link");
                linkCanonical.rel = "canonical";
                linkCanonical.href = href;
                document.head.appendChild(linkCanonical);
            }
        }

        // Update Schema.org (JSON-LD)
        if (schema) {
            let scriptSchema = document.querySelector('script[data-seo-schema]');
            if (!scriptSchema) {
                scriptSchema = document.createElement("script");
                scriptSchema.type = "application/ld+json";
                scriptSchema.setAttribute("data-seo-schema", "");
                document.head.appendChild(scriptSchema);
            }
            scriptSchema.textContent = JSON.stringify(schema);
        }
    }, [title, description, canonical, schema]);
}
